import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from "react-native";
import Svg, { Path } from "react-native-svg";
import { useTheme } from "../styles";
/**
 * Renders a swoosh-y UI element based on a bezier curve for visual design
 * purposes based
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-51}
 */ export var BezierCurve = function(param) {
    var children = param.children, viewBoxWidth = param.viewBoxWidth, viewBoxHeight = param.viewBoxHeight, startPoint = param.startPoint, firstControlPoint = param.firstControlPoint, secondControlPoint = param.secondControlPoint, endPoint = param.endPoint, fill = param.fill, inverse = param.inverse, accessible = param.accessible, role = param.role, ariaLabel = param['aria-label'];
    var theme = useTheme().theme;
    fill || (fill = theme.color.accentTwo100);
    return /*#__PURE__*/ _jsx(View, {
        style: {
            width: '100%',
            aspectRatio: viewBoxWidth / viewBoxHeight
        },
        children: /*#__PURE__*/ _jsxs(Svg, {
            width: "100%",
            height: "100%",
            viewBox: "0 0 ".concat(viewBoxWidth, " ").concat(viewBoxHeight),
            preserveAspectRatio: "none",
            accessible: accessible,
            role: role,
            "aria-label": ariaLabel,
            children: [
                /*#__PURE__*/ _jsx(Path, {
                    d: "\n          M ".concat(startPoint, "\n          C ").concat(firstControlPoint, "\n            ").concat(secondControlPoint, "\n            ").concat(endPoint, "\n          L ").concat(inverse ? "".concat(viewBoxWidth, ",").concat(viewBoxHeight, " 0,").concat(viewBoxHeight) : "".concat(viewBoxWidth, ",0"), "\n          L 0,", 0, "\n        "),
                    fill: fill,
                    strokeWidth: inverse ? 0 : 1,
                    stroke: fill
                }),
                children
            ]
        })
    });
};
